export default [
    {
        path: "/bq-store/account/cost-center",
        component: () => import("./CostCenter.vue"),
        name: "bq.store.account.cost.center",
        meta: {
            requiresAuth: true,
        },
    },
];
